/**
 * Build in-app path to Goals → Reports → Club report with a specific date range.
 * @param {{ quarter?: number, year?: number }} payload
 * @returns {string}
 */
export const buildQuarterGoalsReportPath = (payload) => {
  if (!payload?.quarter || !payload?.year) {
    return '/goals?tab=reports&report=club';
  }

  const startMonth = (payload.quarter - 1) * 3;
  const endMonth = startMonth + 3;
  const endDay = new Date(payload.year, endMonth, 0).getDate();
  const pad = (n) => String(n).padStart(2, '0');
  const startDate = `${payload.year}-${pad(startMonth + 1)}-01`;
  const endDate = `${payload.year}-${pad(endMonth)}-${pad(endDay)}`;

  const params = new URLSearchParams({
    tab: 'reports',
    report: 'club',
    period: 'custom',
    startDate,
    endDate,
  });

  return `/goals?${params.toString()}`;
};

/**
 * Parse YYYY-MM-DD as local calendar date (start of day).
 * @param {string} dateStr
 * @returns {Date}
 */
export const parseLocalDateParam = (dateStr) => {
  const [year, month, day] = dateStr.split('-').map(Number);
  return new Date(year, month - 1, day, 0, 0, 0, 0);
};

/**
 * Parse YYYY-MM-DD as local calendar date (end of day).
 * @param {string} dateStr
 * @returns {Date}
 */
export const parseLocalDateEndParam = (dateStr) => {
  const [year, month, day] = dateStr.split('-').map(Number);
  return new Date(year, month - 1, day, 23, 59, 59, 999);
};
